// src/pages/CheckIn.tsx
import React, { useEffect, useState } from "react";
import QRCodeScanner from "../../components/elements/QRCodeScanner";
import { useNavigate, useParams } from "react-router-dom";
import { decodeBase64Number } from "../../utils/encodeDecode";
import { useToast } from "../../contexts/ToastContext";
import {
  checkRegistrationToken,
  getEventDetail,
} from "../../services/eventService";
import { EventDetail } from "../../types/eventType";

const CheckIn: React.FC = () => {
  const navigate = useNavigate();
  const { showSuccessToast, showErrorToast } = useToast();
  const [loading, setLoading] = useState(true);

  const { id } = useParams(); // <-- this gets "2" from /events/edit/2
  const eventIdEncoded = id ? id : null;
  const eventId = eventIdEncoded ? decodeBase64Number(eventIdEncoded) : null;

  const [event, setEvent] = useState<EventDetail | null>(null);

  const fetchEventDetails = async (id: number) => {
    try {
      const response = await getEventDetail(id);
      setEvent(response.data.data);
    } catch (error) {
      const errorResponse = (error as any)?.response?.data || error;
      if (errorResponse?.error === "EVENT_NOT_PUBLISHED") {
        showErrorToast(errorResponse?.message || "Event not published yet.");
        navigate("/events"); // Redirect to events list if event is not published
      }
      if (errorResponse?.error === "EVENT_NOT_FOUND") {
        showErrorToast(errorResponse?.message || "Event not found.");
        navigate("/events"); // Redirect to events list if event is not published
      }
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const fetchBookingDetails = async (bookingToken: string) => {
    const data = {
      event_id: eventId,
      event_title: event?.title,
      registration_token: bookingToken,
    };
    const response = await checkRegistrationToken(eventId || 0, bookingToken);
    return { ...data, ...response.data.data.attendee };
  };

  useEffect(() => {
    if (!eventId) {
      showErrorToast("Invalid Event.");
      navigate("/events");
    } else {
      fetchEventDetails(eventId);
    }
  }, []);

  return (
    <section className="events_list blog-two">
      <div className="container">
        <div className="event_list_heading flex-column-responsive">
          <div className="section-title">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">
                Scan QR Code to Event Check-In
              </span>
            </div>
            <h2 className="section-title__title section-title__title--two">
              {loading ? (
                <i className="fas fa-spinner fa-spin"></i>
              ) : (
                <>Event: {event?.title}</>
              )}
            </h2>
            {!loading && (
              <div className="check-in-count mt-3">
                <p>
                  <strong>Checked-In Attendees: </strong>{" "}
                  {event?.totalCheckedInAttendees}/
                  {event?.attendee_setting?.attendee_registered}
                </p>
              </div>
            )}
          </div>
          <div className="button-box">
            <button
              type="button"
              className="event-details__ticket-two-btn thm-btn"
              onClick={() => navigate(-1)}
            >
              Back to Event Attendees
            </button>
          </div>
        </div>
        {!loading && (
          <div className="schedule-two__main-tab-box tabs-box">
            <QRCodeScanner
              onScanSuccess={fetchBookingDetails}
              onCheckInSuccess={(attendeesCount) => {
                setEvent((prev) =>
                  prev
                    ? {
                        ...prev,
                        totalCheckedInAttendees:
                          (Number(prev.totalCheckedInAttendees) || 0) +
                          Number(attendeesCount),
                      }
                    : prev
                );
              }}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default CheckIn;
